/**
 * Created by smizrahi on 7/26/16.
 */
/*eslint-disable no-undef*/
export default class ConfigConverter {

    constructor() {

    }

    /**
     * Convert the configuration from XML to JS using xml2js
     *
     * @param configurationRaw
     * @returns {Promise} An array of parameters if success, an error if failed
     */
    convert(configurationRaw) {
        return new Promise((resolve, reject) => {
            if (configurationRaw && configurationRaw != '') {
                var parseString = require('xml2js').parseString;
                // The option explicitChildren is used to avoid merging sub properties
                // Take a tour on https://github.com/Leonidas-from-XIV/node-xml2js documentation
                parseString(configurationRaw, {
                    explicitChildren: true,
                    preserveChildrenOrder: true,
                    attrkey: 'attr',
                    childkey: 'child',
                    charkey: 'val',
                    trim: true
                }, function (err, result) {
                    if (err) {
                        reject(Error(err.message, 1001));
                    } else {
                        resolve(result);
                    }
                });
            } else {
                reject(Error('Empty configuration downloaded', 1000));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/converter/ConfigConverter.js